import { apiRequest } from "../../utils/apiUtils";

export const communityApi = {
  getOpenChatList: () =>
    apiRequest<any>("get", "/community/open-chat", { fullResponse: true }),
};
